import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import * as Chartist from 'chartist';

import { AuthService } from '../../../shared/services/auth.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { firstValueFrom } from 'rxjs';
import { DashBoardService } from './dashboard.service';
//import { BarChart } from 'chartist';

let self: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit {
  company!: string;
  loading: boolean = false;
  submitted = false;
  saving: boolean = false;
  areas: any[] = [];
  grossProductData: any[] = [];
  filter: IFilter = {
    filters: {
      scheduledStart: new Date().toISOString().substring(0, 10),
    },
    sort: '',
    skip: 0,
    limit: 20
  };
  isLoading = false;
  selectDate: string = "currentMonth";

  //sales
  selectDateSales: string = "currentYear";
  startDateSales!: string;
  endDateSales!: string;

  //timeTrack
  maxDate!: string;
  selectDateTimeTrack!: string;
  startDateTimeTrack!: string;
  endDateTimeTrack: string = new Date().toISOString()

  // como string
  startDate!: string;
  endDate!: string;
  startDateISO!: string;
  endDateISO!: string;

  selectedDayStart!: string;
  selectedDayEnd!: string;


  //TaskRequests
  taskRequests: any = { pending: 0, approved: 0, rejected: 0 };
  loadingTaskRequests: boolean = true;
  isLoadingTaskRequests: boolean = false;

  //Task
  tasks: any = { completed: 0, ongoing: 0, invoiced: 0 };
  loadingTask: boolean = true;
  isLoadingTask: boolean = false;

  //Quotes
  quotes: any = { approved: 0, pending: 0 };
  loadingQuotes: boolean = true;
  isLoadingQuotes: boolean = false;

  //Invoices
  invoices: any = { paid: 0, total: 0, overdue: 0, draft: 0 };
  loadingInvoices: boolean = true;
  isLoadingInvoices: boolean = false;

  //Sales
  sales: any[] = [];
  loadingSales: boolean = true;
  isLoadingSales: boolean = false;

  //TimeTracks
  timeTracks: any[] = [];
  loadingTimeTracks: boolean = true;
  isLoadingTimeTracks: boolean = false;

  constructor(
    private _router: Router,
    public _DashboardService: DashBoardService,
    public _AuthService: AuthService,
    private _UtilsService: UtilsService,
  ) {
    self = this;
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  initDates() {

    //sales
    this.startDateSales = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), 0, 1, 0, 0, 0).toISOString()).substring(0, 10);
    this.endDateSales = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), 11, 31, 23, 59, 59).toISOString()).substring(0, 10);

    //timeTrack
    this.selectDateTimeTrack = this._UtilsService.date.toLocale(new Date().toISOString()).substring(0, 10);
    this.startDateTimeTrack = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).toISOString();
    this.endDateTimeTrack = new Date().toISOString()

    // como string
    this.startDate = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0).toISOString()).substring(0, 10);
    this.endDate = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 23, 59, 59).toISOString()).substring(0, 10);
    this.startDateISO = this.startDate;
    this.endDateISO = this.endDate;

    this.selectedDayStart = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0).toISOString()).substring(0, 10);
    this.selectedDayEnd = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()).toISOString()).substring(0, 10);
  }


  async ngOnInit() {
    this.initDates();

    this.maxDate = new Date().toISOString().split('T')[0];
    this.company = this._AuthService.companyId();
    await this.getTaskDashBoards();

    await this.getTaskRequestsDashBoards();
    await this.getQuotesDashBoards();
    await this.getInvoicesDashBoards();

    await this.getSalesDashBoards();
    await this.getTimeTracksDashBoards();

  }

  createChart(): void {
    // Preparar los datos en el formato adecuado para Chartist
    const labels = this.sales.map(data => data.month);
    const sales = this.sales.map(data => data.sale);
    const paid = this.sales.map(data => data.paid);

    const chartData = {
      labels: labels,
      series: [
        sales,
        paid
      ]
    };

    // Opciones de la gráfica
    const options = {
      seriesBarDistance: 5, // Reduce la distancia entre las barras
      axisX: {
        showLabel: true,
        showGrid: false
      },
      axisY: {
        onlyInteger: true,
        offset: 40, // Espacio reservado para las etiquetas
        labelInterpolationFnc: (value: number) => value.toLocaleString('es-ES')
      },
      chartPadding: {
        left: 20,
        right: 10,
        top: 20, // Incrementa el margen superior
        bottom: 10
      },
      width: '100%', // Comprime la gráfica si está en un contenedor flexible
      height: '290px' // Reduce la altura total de la gráfica
    };

    // Crear la gráfica
    new Chartist.BarChart('.ct-chart', chartData, options);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      // console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        //this.calculateDay()
        this.getTaskDashBoards();
        this.getTaskRequestsDashBoards();
        this.getQuotesDashBoards();
        this.getInvoicesDashBoards();
        //this.getTasks(true);
      }
    }, 1000);
  }

  selectedDayChange() {
    this.startDate = this._UtilsService.date.toUTC(this.selectedDayStart + 'T00:00:00.000Z');
    this.endDate = this._UtilsService.date.toUTC(this.selectedDayEnd + 'T23:59:59.999Z');
    this.lazySearch();
  }


  recalculateDay() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDay = new Date().getDate();

    if (this.selectDate === 'currentMonth') {
      this.startDate = new Date(currentYear, currentMonth, 1, 0, 0, 0).toISOString();
      this.endDate = new Date(currentYear, currentMonth, currentDay, 23, 59, 59).toISOString();
    }

    if (this.selectDate === 'lastMonth') {
      this.startDate = new Date(currentYear, currentMonth - 1, 1).toISOString();
      this.endDate = new Date(currentYear, currentMonth, 0, 23, 59, 59).toISOString();
    }

    if (this.selectDate === 'today') {
      this.startDate = new Date(currentYear, currentMonth, currentDay, 0, 0, 0).toISOString();
      this.endDate = new Date(currentYear, currentMonth, currentDay, 23, 59, 59).toISOString();
    }

    if (this.selectDate === 'personalized') {
      this.startDate = this._UtilsService.date.toUTC(this.selectedDayStart + 'T00:00:00.000Z');
      this.endDate = this._UtilsService.date.toUTC(this.selectedDayEnd + 'T23:59:59.999Z');
    }

    this.getTaskDashBoards();
    this.getTaskRequestsDashBoards();
    this.getQuotesDashBoards();
    this.getInvoicesDashBoards();
  }

  recalculateSales() {
    const currentYear = new Date().getFullYear();

    if (this.selectDateSales === 'currentYear') {
      this.startDateSales = new Date(currentYear, 0, 1, 0, 0, 0).toISOString();
      this.endDateSales = new Date(currentYear, 11, 31, 23, 59, 59).toISOString();
    }

    if (this.selectDateSales === 'lastYear') {
      this.startDateSales = new Date(currentYear - 1, 0, 1, 0, 0, 0).toISOString();
      this.endDateSales = new Date(currentYear - 1, 11, 31, 23, 59, 59).toISOString();
    }

    this.getSalesDashBoards();
  }

  recalculateTimeTrack() {
    const selectedDate = new Date(this.selectDateTimeTrack);

    if (selectedDate.toDateString() === new Date().toDateString()) {
      this.startDateTimeTrack = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).toISOString();
      this.endDateTimeTrack = new Date().toISOString();
    } else {
      this.startDateTimeTrack = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() + 1, 0, 0, 0).toISOString();
      this.endDateTimeTrack = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() + 1, 23, 59, 59).toISOString();
    }

    this.getTimeTracksDashBoards();
  }

  //TaskRequests
  async getTaskRequestsDashBoards() {
    this.loadingTaskRequests = true;
    const data = await firstValueFrom(this._DashboardService.getTaskRequestStatusSummary(this.startDate, this.endDate, this.company));
    this.taskRequests = data;
    this.loadingTaskRequests = false;
  }

  //Task
  async getTaskDashBoards() {
    this.loadingTask = true;
    const data = await firstValueFrom(this._DashboardService.getTaskStatusSummary(this.startDate, this.endDate, this.company));
    this.tasks = data;
    this.loadingTask = false;
  }

  //Quotes
  async getQuotesDashBoards() {
    this.loadingQuotes = true;
    const data = await firstValueFrom(this._DashboardService.getQuotesSummary(this.startDate, this.endDate, this.company));
    this.quotes = data;
    this.loadingQuotes = false;
  }

  //Invoices
  async getInvoicesDashBoards() {
    this.loadingInvoices = true;
    //console.log(this.startDate, this.endDate);
    const data = await firstValueFrom(this._DashboardService.getBillingDocumentSummary(this.startDate, this.endDate, this.company));
    this.invoices = data;
    this.loadingInvoices = false;
  }

  //Sales
  async getSalesDashBoards() {
    this.loadingSales = true;
    const data: any = await firstValueFrom(this._DashboardService.getSalesSummary(this.startDateSales, this.endDateSales, this.company));
    const totalMonths = 12;
    const completeSales: any = [];
    for (let i = 1; i <= totalMonths; i++) {
      completeSales.push({ month: i, sale: 0, paid: 0 });
    }

    data.forEach((saleItem: any) => {
      const index = completeSales.findIndex((item: any) => item.month === saleItem.month);
      if (index !== -1) {
        completeSales[index] = saleItem;
      }
    });
    this.sales = completeSales;
    this.loadingSales = false;

    console.log(this.sales)
    this.createChart();
  }

  //TimeTracks
  async getTimeTracksDashBoards() {
    this.loadingTimeTracks = true;
    // const startDateTimeTrack = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).toISOString();
    const endDateTimeTrack = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59).toISOString();
    // console.log(startDateTimeTrack, endDateTimeTrack)
    // const data = await firstValueFrom(this._DashboardService.getTimeTrackSummary(startDateTimeTrack, endDateTimeTrack, this.company));
    console.log(this.startDateTimeTrack, this.endDateTimeTrack)
    const data: any = await firstValueFrom(this._DashboardService.getTimeTrackSummary(this.startDateTimeTrack, endDateTimeTrack, this.company));
    this.timeTracks = [
      { label: `Trabajos con fichaje (${data.tasksWithTimetracks})`, value: data.tasksWithTimetracks },
      { label: `Trabajos sin fichaje (${data.tasksWithoutTimetracks})`, value: data.tasksWithoutTimetracks }
    ];

    console.log(data)
    // Configura los datos para Chartist
    const chartData = {
      series: this.timeTracks.map(track => track.value) // Extrae solo los valores
    };

    console.log('eeeeee')
    // Renderiza el gráfico
    new Chartist.PieChart('#pastel', chartData, {
      labelInterpolationFnc: (value, idx) => {
        return `${this.timeTracks[idx].label}`;
      }
    });
    this.loadingTimeTracks = false;
  }

  getMonthName(monthNumber: number): string {
    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return monthNames[monthNumber - 1];
  }

  customizeMonthLabel = (arg: any) => {
    return this.getMonthName(arg.value);
  };


  redirectTaskRequests() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'task-requests']);
  }

  redirectQuotes() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'quotes']);
  }

  redirectTasks() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-list']);
  }

  redirectBillDocs() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'billing-documents']);
  }

  redirectTimeTracks() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'time-track']);
  }

  customizeTooltip = (point: any) => {
    console.log(point)
    const monthNames = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const monthName = monthNames[point.argument - 1];
    const valueFormatted = this.formatMoney(point.valueText, true);

    return {
      text: `${point.seriesName} en ${monthName}: ${valueFormatted}`
    };
  }

  formatMoney(valueText: string, needSymbol: boolean = false): string {
    // Convertir valueText a número
    let valueNumber = parseFloat(valueText.replace(',', '.'));

    // Formatear el número en el formato adecuado: miles con puntos, decimales con coma
    let [integerPart, decimalPart] = valueNumber.toFixed(2).split('.');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Añadir puntos para miles

    let formattedValue = `${integerPart},${decimalPart}`;

    // Añadir el símbolo de moneda si es necesario
    if (needSymbol) {
      const symbol = this._AuthService.currency();
      const currAlignment = this._AuthService.alignmentCurrency();
      formattedValue = currAlignment === "RIGHT"
        ? `${formattedValue} ${symbol}`
        : `${symbol} ${formattedValue}`;
    }

    return formattedValue;
  }


  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  startAnimationForLineChart(chart: any) {
    let seq: any, delays: any, durations: any;
    seq = 0;
    delays = 80;
    durations = 500;

    chart.on('draw', function (data: any) {
      if (data.type === 'line' || data.type === 'area') {
        data.element.animate({
          d: {
            begin: 600,
            dur: 700,
            from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
            to: data.path.clone().stringify(),
            easing: Chartist.Svg.Easing.easeOutQuint
          }
        });
      } else if (data.type === 'point') {
        seq++;
        data.element.animate({
          opacity: {
            begin: seq * delays,
            dur: durations,
            from: 0,
            to: 1,
            easing: 'ease'
          }
        });
      }
    });

    seq = 0;
  };
  startAnimationForBarChart(chart: any) {
    let seq2: any, delays2: any, durations2: any;

    seq2 = 0;
    delays2 = 80;
    durations2 = 500;
    chart.on('draw', function (data: any) {
      if (data.type === 'bar') {
        seq2++;
        data.element.animate({
          opacity: {
            begin: seq2 * delays2,
            dur: durations2,
            from: 0,
            to: 1,
            easing: 'ease'
          }
        });
      }
    });

    seq2 = 0;
  };
}
